const queryPermission = async (name: PermissionName): Promise<PermissionState | null> => {
  try {
    const result = await navigator.permissions.query({ name })
    return result.state
  } catch {
    // Some browsers don't support querying certain permissions (e.g. 'camera' on Firefox)
    return null
  }
}

export const getMediaPermissions = async (checkAudio: boolean, checkVideo?: boolean): Promise<void> => {
  const [audioState, videoState] = await Promise.all([
    checkAudio ? queryPermission('microphone') : Promise.resolve<PermissionState | null>('granted'),
    checkVideo ? queryPermission('camera') : Promise.resolve<PermissionState | null>('granted'),
  ])

  // If any permission is explicitly denied, throw so the caller can show the right popup
  if (audioState === 'denied' || videoState === 'denied') {
    throw new DOMException('Permission denied', 'NotAllowedError')
  }

  // If all queried permissions are already granted, no need to prompt again
  if (audioState === 'granted' && videoState === 'granted') {
    return
  }

  // At least one permission is in 'prompt' state (or query unsupported) — request via getUserMedia
  // @ts-expect-error TS2379 -- MIGRATION: not approved, fix when encountered
  const streams = await navigator.mediaDevices.getUserMedia({
    audio: checkAudio,
    video: checkVideo,
  })
  streams.getTracks().forEach((track) => {
    if (track.readyState === 'live') {
      track.stop()
    }
  })
}
